export const defaultCrewRequirement = (currentlyAssigned: number) => {
  return {
    id: 'new',
    requirementType: 'crew_member',
    currentlyAssigned: currentlyAssigned || 0,
    totalNeeded: 0,
  };
};
